// src/api/reports.ts
import { apiClient } from '@/plugins/axios';

// OJO: si tu apiClient YA incluye "/api" en baseURL, usa "/v1/report-pdf" o "/report-pdf" según tu backend.
// Dado tu patrón previo ("/quotations", "/dashboard/..."), lo más seguro es:
const PATH = '/report-pdf'; // cambia a '/report-pdf' si tu baseURL ya es '/api/v1'

const exportPDF = (params: { from?: string; to?: string; scope?: string }) => {
  return apiClient.get(PATH, {
    params,
    responseType: 'blob',
  });
};

const exportExcel = (params: { from?: string; to?: string; scope?: string }) => {
  return apiClient.get(PATH, {
    params: { ...params, export: 'excel' },
    responseType: 'blob',
  });
};

export default { exportPDF, exportExcel };
